export default "__VITE_ASSET__C9EqBY1U__"